import React from 'react';
import { FieldRenderer } from '../fieldRegistry';
import { AudioField } from './AudioField';
import { MediaFile } from '../types';

export const renderAudioField: FieldRenderer = (
  field,
  formState,
  updateFormState,
  context
) => {
  const audioFile = formState[field.name] as MediaFile | null;

  return (
    <AudioField
      key={field.name}
      audioFile={audioFile}
      hasExistingAudio={!!context?.initialAudioId}
      onAudioSelect={(file: MediaFile | null) => {
        updateFormState(prev => ({
          ...prev,
          [field.name]: file
        }));
      }}
    />
  );
};
